import AppHeading from './AppHeading.vue';

export * from './types';
export default AppHeading;



// WEBPACK FOOTER //
// ./src/uikit/typography/Heading/index.ts